// @flow
import { call, delay, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { getLogger } from 'utils/logger';
import * as actions from 'data/nps/npsActions';
import { createDialog } from 'data/rootUi/actions';
import { mkRootUiData } from 'data/rootUi/types';
import { DIALOG_TYPE as DIALOG_TYPE_NPS_SURVEY } from 'components/Dialogs/NPSSurveyDialog/types';
import { qcsSyncCreateResource } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { getAuthSession } from 'utils/auth/utils';
import AuthSession from 'utils/auth/types';
import { getFeatureFlags } from 'utils/featureFlags/selectors';
import store from 'store';

const log = getLogger('data/nps/npsSagas');

function* checkIfNPSSurveyRequested() {

  const featureFlags = yield call(getFeatureFlags, store.getState());
  const npsDelay : number = featureFlags.get('nps');
  if (npsDelay > 0) {
    log.log('checkIfNPSSurveyRequestedAction...');
    const authSession : AuthSession = yield call(getAuthSession);
    if (authSession.surveyRequested) {
      log.log(`Show NPS Survey...in ${npsDelay} msec`);
      yield delay(npsDelay);

      log.log('Show NPS Survey...');
      const dialogData = mkRootUiData({
        id: 'NPS',
        type: DIALOG_TYPE_NPS_SURVEY,
        allowNesting: true,
      });
      yield put(createDialog(dialogData));
    }
  }
}

function* checkIfNPSSurveyRequestedActionWatcher(): Generator<*, *, *> {
  yield takeLatest(actions.checkIfNPSSurveyRequestedAction, checkIfNPSSurveyRequested);
}

export function* postNPSSurveyResultActionWatcher(): Generator<*, *, *> {
  yield takeEvery(actions.postNPSSurveyResultAction,
    qcsSyncCreateResource,
    mkQcsSyncResourceConfig({
      resourceName: 'nps survey',
      resourceBaseUrl: '/users/survey',
      successAction: actions.postNPSSurveyResultSuccessAction,
      failureAction: actions.postNPSSurveyResultFailureAction,
    }));
}

export default [
  checkIfNPSSurveyRequestedActionWatcher,
  postNPSSurveyResultActionWatcher,
];
